import { Post } from "api";
import { Partner } from "redux/partners/reducer";

async function getPartners({
  page,
  pageSize,
  filters,
}: {
  page: number;
  pageSize: number;
  filters?: Record<string, any>;
}): Promise<{ data: Partner[]; total: number }> {
  try {
    const convertedFilters = Object.entries(filters || {}).reduce(
      (acc, [key, value]) => {
        if (value === "true") {
          acc[key] = true;
        } else if (value === "false") {
          acc[key] = false;
        } else {
          acc[key] = value;
        }
        return acc;
      },
      {} as Record<string, any>
    );

    const response = await Post("/manage/partners", {
      limit: pageSize,
      page: page,
      filters: {
        ...convertedFilters,
      },
    });

    return {
      data: response.partnerList,
      total: response.resultCount,
    };
  } catch (error) {
    console.warn("Error fetching partners: ", error);
  }
}

export { getPartners };
